import Quill from 'quill'

// Substitui o History nativo do Quill. Operações de tabela (menu de contexto
// e botões append da toolbar) são marcadas com snapshots de DOM completos e
// restauradas via clipboard.convert + setContents (mesmo caminho do paste),
// pois a reaplicação de deltas cirúrgicos em containers td/tr/table é
// quebrada no quill-table@1.0.0 (otimize frágil + formatação td no undo).
// A digitação e demais comandos usam o caminho nativo (super).
const QuillHistory = Quill.import('modules/history')

class TableAwareHistory extends QuillHistory {
  constructor (quill, options) {
    super(quill, options)
    this.pendingTableSnap = null
    this.activeTableOperation = null
  }

  markTableOperation (beforeHtml, beforeIndex) {
    this.cutoff()
    const token = { undoLength: this.stack.undo.length }
    this.pendingTableSnap = { token, undo: { html: beforeHtml, index: beforeIndex } }
    this.activeTableOperation = null
    return token
  }

  completeTableOperation (token, afterHtml, afterIndex) {
    const operation = this.activeTableOperation
    if (operation && operation.token === token && operation.entry === this.stack.undo[this.stack.undo.length - 1]) {
      const entry = operation.entry
      entry.tableSnap.redo = { html: afterHtml, index: afterIndex }
    }
    this.pendingTableSnap = null
    this.activeTableOperation = null
  }

  abortTableOperation (token) {
    if (!token || (this.pendingTableSnap && this.pendingTableSnap.token === token) || (this.activeTableOperation && this.activeTableOperation.token === token)) {
      this.pendingTableSnap = null
      this.activeTableOperation = null
    }
  }

  record (changeDelta, oldDelta) {
    super.record(changeDelta, oldDelta)
    if (this.pendingTableSnap) {
      const pending = this.pendingTableSnap
      const entry = this.stack.undo[this.stack.undo.length - 1]
      if (entry && this.stack.undo.length > pending.token.undoLength) {
        entry.tableSnap = {
          undo: { html: pending.undo.html, index: pending.undo.index },
          redo: null
        }
        this.activeTableOperation = { token: pending.token, entry }
      }
      this.pendingTableSnap = null
    }
  }

  change (source, dest) {
    const entry = this.stack[source][this.stack[source].length - 1]
    const snap = entry && entry.tableSnap ? entry.tableSnap[source] : null
    if (snap && snap.html != null) {
      this.stack[source].pop()
      this.stack[dest].push(entry)
      this.lastRecorded = 0
      // Restore com source USER dispara text-change (onEditorChange -> Vuex/Vuelidate);
      // ignoreChange impede que o restore seja gravado como nova entrada do histórico.
      this.ignoreChange = true
      try {
        const delta = this.quill.clipboard.convert(snap.html)
        this.quill.setContents(delta, Quill.sources.USER)
      } finally {
        this.ignoreChange = false
      }
      if (typeof snap.index === 'number') {
        this.quill.setSelection(snap.index)
      }
      return
    }
    super.change(source, dest)
  }
}

export default TableAwareHistory
